<ng-container *ngIf="isDesktop; else webShell">
  <div class="desktop-app" [class.desktop-app--darwin]="desktopIsDarwin">
    <div class="dt-titlebar">
      <div class="dt-brand">
        <img src="assets/spectyra-icon.png" alt="Spectyra" class="dt-logo-icon" />
        <span class="dt-wordmark" [routerLink]="isDesktopPro ? '/desktop/live' : '/desktop/home'">
          Spectyra<span class="dt-edition" *ngIf="!isDesktopPro"> for OpenClaw</span>
        </span>
      </div>
      <div class="dt-spacer"></div>
    </div>

    <!-- OpenClaw edition nav -->
    <nav class="dt-nav" *ngIf="!isDesktopPro">
      <a class="dt-nav-item" routerLink="/desktop/home" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }">Home</a>
      <a class="dt-nav-item" routerLink="/desktop/skills" routerLinkActive="active">Skills</a>
      <a class="dt-nav-item" routerLink="/desktop/assistants" routerLinkActive="active">Assistants</a>
      <a class="dt-nav-item" routerLink="/desktop/live" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: false }">
        <span class="dt-live-dot"></span>Live
      </a>
      <a class="dt-nav-item" routerLink="/desktop/settings" routerLinkActive="active">Settings</a>
      <a class="dt-nav-item" *ngIf="showSuperuserLink" routerLink="/superuser" routerLinkActive="active">Superuser</a>
    </nav>

    <!-- Pro edition nav -->
    <nav class="dt-nav" *ngIf="isDesktopPro">
      <a class="dt-nav-item" routerLink="/desktop/live" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: false }">
        <span class="dt-live-dot"></span>Live
      </a>
      <a class="dt-nav-item" routerLink="/desktop/sessions" routerLinkActive="active">Sessions</a>
      <a class="dt-nav-item" routerLink="/desktop/history" routerLinkActive="active">History</a>
      <a class="dt-nav-item" routerLink="/desktop/compare" routerLinkActive="active">Compare</a>
      <a class="dt-nav-item" routerLink="/desktop/runs" routerLinkActive="active">Runs</a>
      <a class="dt-nav-item" routerLink="/desktop/openclaw" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: false }">OpenClaw</a>
      <a class="dt-nav-item" routerLink="/desktop/agent-companion" routerLinkActive="active">Setup</a>
      <a class="dt-nav-item" routerLink="/desktop/security" routerLinkActive="active">Security</a>
      <a class="dt-nav-item" routerLink="/desktop/settings" routerLinkActive="active">Settings</a>
      <a class="dt-nav-item" *ngIf="showSuperuserLink" routerLink="/superuser" routerLinkActive="active">Superuser</a>
    </nav>

    <main class="desktop-main">
      <router-outlet></router-outlet>
      <footer class="site-mission-footer" aria-label="Spectyra mission">
        <p>At Spectyra, we believe the future of AI must be both powerful and responsible.</p>
        <p>
          As part of our core mission, we commit to allocating 10% of all profits to organizations advancing AI safety
          and guardrails.
        </p>
      </footer>
    </main>
  </div>
</ng-container>

<ng-template #webShell>
  <div class="app-container">
    <mat-toolbar class="app-header" color="primary">
      <div class="header-left">
        <button
          *ngIf="isAuthenticated"
          mat-icon-button
          (click)="toggleSidebar()"
          class="sidebar-toggle"
          aria-label="Toggle sidebar"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <h1 routerLink="/" class="logo">
          <img src="assets/spectyra-icon.png" alt="Spectyra" class="logo-icon" />
          Spectyra
        </h1>
      </div>

      <div class="header-right">
        <ng-container *ngIf="isAuthenticated">
          <app-org-switcher></app-org-switcher>
          <ng-container *ngIf="workspacePlanState$ | async as ws">
            <span class="plan-badge" *ngIf="ws.headerPlanLabel" title="Current workspace plan">{{
              ws.headerPlanLabel
            }}</span>
          </ng-container>
        </ng-container>

        <span *ngIf="!isAuthenticated" class="auth-links">
          <a routerLink="/contact">Contact</a>
          <a routerLink="/login">Login</a>
          <a routerLink="/register">Sign Up</a>
        </span>
        <span *ngIf="isAuthenticated" class="auth-links">
          <span class="user-email">{{ userEmail }}</span>
          <button (click)="logout()" class="btn-logout">Logout</button>
        </span>
      </div>
    </mat-toolbar>

    <div class="app-body">
      <mat-sidenav-container class="sidenav-container">
        <mat-sidenav
          #sidenav
          [(opened)]="sidebarOpen"
          mode="side"
          class="app-sidenav"
          [class.collapsed]="sidebarCollapsed"
          [style.width.px]="sidebarCollapsed ? 64 : 256"
        >
          <nav class="sidebar-nav">
            <ng-container *ngFor="let item of navItems; let i = index">
              <div
                *ngIf="
                  isAuthenticated &&
                  item.section &&
                  !sidebarCollapsed &&
                  (item.section !== 'Admin' || showAdminLink || showSuperuserLink)
                "
                class="nav-section-label"
                [class.first]="i === 0"
              >{{ item.section }}</div>
              <div
                *ngIf="
                  isAuthenticated &&
                  item.section &&
                  sidebarCollapsed &&
                  i > 0 &&
                  (item.section !== 'Admin' || showAdminLink || showSuperuserLink)
                "
                class="nav-section-divider"
              ></div>

              <a
                *ngIf="(!item.requiresAuth || isAuthenticated) && (!item.adminOnly || showAdminLink) && (!item.superuserOnly || showSuperuserLink)"
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: item.route === '/overview' || item.route === '/contact' || item.route === '/in-app' }"
                class="nav-item"
                [class.collapsed]="sidebarCollapsed"
              >
                <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
                <span class="nav-label" *ngIf="!sidebarCollapsed">{{ item.label }}</span>
              </a>
            </ng-container>
          </nav>
        </mat-sidenav>

        <mat-sidenav-content class="app-main">
          <router-outlet></router-outlet>
          <footer class="site-mission-footer" aria-label="Spectyra mission">
            <p>At Spectyra, we believe the future of AI must be both powerful and responsible.</p>
            <p>
              As part of our core mission, we commit to allocating 10% of all profits to organizations advancing AI
              safety and guardrails.
            </p>
            <p class="footer-contact"><a routerLink="/contact">Contact us</a></p>
          </footer>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </div>
</ng-template>
